import { render, staticRenderFns } from "./AtomAvatarEquipo.vue?vue&type=template&id=c3a46b12&"
import script from "./AtomAvatarEquipo.vue?vue&type=script&lang=js&"
export * from "./AtomAvatarEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports